import css from 'styled-jsx/css'

const autoLibraryStyle = css.global`
  .auto-library-wrap .item-wrap{
    min-height: 56px;
    border-bottom: 0.5px solid #e6e8f2;
    display: flex;
  }

  .auto-library-wrap .item-wrap .name{
    height: 56px;
    line-height: 56px;
    font-size: 14px;
    color: #979aa8;
    width: 80px;
    text-align: center;
  }
  .auto-library-wrap .item-wrap .item-list{
    flex: 1;
    padding-bottom: 8px;
  }
  .auto-library-wrap .item-wrap .item-child{
    display: inline-block;
    margin: 15px 2px 0 0;
    padding: 4px 8px;
    cursor: pointer;
    -webkit-transition: all 0.1s ease-in-out;
    transition: all 0.1s ease-in-out;
    border-radius: 2px;
  }
  .auto-library-wrap .item-wrap .item-child.big-mr{
    margin-right: 35px
  }
  .auto-library-wrap .item-wrap .active{
    background-color: #ffcc32;
  }
  .auto-library-wrap .item-wrap .item-child:hover {
    background: rgba(255, 225, 0, 0.2);
  }

`
export default autoLibraryStyle
